module.exports = __webpack_public_path__ + "img/repair.f0e34cc9.png";